import { type RouteObject } from 'react-router-dom';
import { availableScreen, firstMvp } from '@/lib/productScope';
import Preparing from '@/pages/Preparing';

/** A deferred URL shows a static preparing page before its original data reader mounts. */
export function productRoutes(
  routes: RouteObject[],
  mvp = firstMvp,
): RouteObject[] {
  return routes.map((route) => {
    const screen: unknown = route.handle?.screen;
    if (typeof screen === 'string' && !availableScreen(screen, mvp)) {
      return {
        ...route,
        element: <Preparing screen={screen} />,
        children: undefined,
      } as RouteObject;
    }
    if (route.index) return route;
    return {
      ...route,
      children: route.children && productRoutes(route.children, mvp),
    };
  });
}
